"use strict";var u=(l=>(l.Full="full",l.Basic="basic",l.Minimal="minimal",l.None="none",l))(u||{});export default u;
//# sourceMappingURL=AnimationMode.js.map
